var showroomIdCookie = "showroom-id";
var showroomTitleCookie = "showroom-title";
var arrShowroomInventory = { inventory: [{ locationId: "", qty: 0 }] };

var clsShowroomDisplayName = ".showroom-display-name";
var clsShowroomInventory = ".showroom-inventory";

// set showroom cookies
function updateCustomerShowroom(locationId, locationTitle) {
  setCookie(showroomIdCookie, locationId, 100); // 100 days
  setCookie(showroomTitleCookie, locationTitle, 100); // 100 days
  displayShowroomSelected();
  displayShowroomInventory(arrShowroomInventory);
  closeLocationDrawer();
}

//if showroom cookies and server showroom customer-metafield do not align, set them same
function updateCustomerShowroomAPI(
  customerId,
  currentShowroomId,
  currentShowroomName
) {
  var showroomId = getCookie(showroomIdCookie);

  if (showroomId == null && currentShowroomId != "") {
    //set cookies showroom same as server showroom customer-metafield
    updateCustomerShowroom(currentShowroomId, currentShowroomName);
  } else if (showroomId != null && showroomId != currentShowroomId) {
    //set server showroom customer-metafield same as cookies showroom
    callCustomerShowroomAPI(customerId, showroomId);
  }
}

//set server showroom customer-metafield
async function callCustomerShowroomAPI(customerid, locationid) {
  try {
    const response = await fetch(
      "https://app.russellhendrix.com/api/external/location/updatecustomershowroom",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          CustomerId: customerid,
          DisplayName: locationid,
        }),
      }
    );
    const data = await response.text();
    if (customerid != '') {         
      if(data == 'Specified showroom display name not found.')
      {
        console.error("Error updating customer showroom:", error);
          document.getElementById("gv-errors").innerText =
            "Error updating customer showroom. Please try again later.";          
      }
      else if(data == 'Customer showroom metafield updated successfully!'){
        location.reload();
      }      
    }
    //console.log(data);
  } catch (error) {
    console.error("Error updating customer showroom:", error);
    document.getElementById("gv-errors").innerText =
      "Error updating customer showroom. Please try again later.";
  }
}

//Open right showroom menu
function openLocationDrawer() {
  setTimeout(() => {
    document
      .querySelector("location-drawer")
      .classList.add("animate", "active");
  });
  document.body.classList.add("overflow-hidden");
}

//Close right showroom menu
function closeLocationDrawer() {
  document.querySelector("location-drawer").classList.remove("active");
  document.body.classList.remove("overflow-hidden");
}

//Set cookie
function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

//Get cookie
function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

//Display the selected showroom title
function displayShowroomSelected() {
  var showroomTitle = getCookie(showroomTitleCookie);
  var showroomId = getCookie(showroomIdCookie);
  if (showroomTitle.length > 0) {
    document.querySelectorAll(clsShowroomDisplayName).forEach(function (a) {
      a.innerText = showroomTitle;
    });

    document.querySelectorAll(".gv-inventory-info").forEach(function (a) {
      a.style.display = "none";
    });
    document
      .querySelectorAll(".gv-inventory-" + showroomId)
      .forEach(function (a) {
        a.style.display = "block";
      });
  }
}

//Display the selected showroom inventory
function displayShowroomInventory(showroomInventory) {
  var showroomId = getCookie(showroomIdCookie);
  var totalQty = showroomInventory.inventory
    .filter((item) => item.locationId === showroomId)
    .reduce((sum, item) => sum + parseInt(item.qty), 0);

  if (parseInt(totalQty) < 0) {
    totalQty = 0;
  }

  document.querySelectorAll(clsShowroomInventory).forEach(function (a) {
    var parentDiv = a.parentElement;
    if (totalQty == 0) {
      parentDiv.classList.remove("gv-text-tgreen");
      parentDiv.classList.add("gv-text-red");
    } else {
      parentDiv.classList.add("gv-text-tgreen");
      parentDiv.classList.remove("gv-text-red");
    }
    if (showroomId != null) a.innerText = totalQty + " In showroom*";
  });
}

//After document load, bind the set showroom button click and showroom title click event in left showroom menu
document.addEventListener("DOMContentLoaded", function () {
  var openDrawerButton = document.getElementById("gv-btn-Showrooms");

  //bind the set showroom button click
  document.querySelectorAll(".gv-btn-Showrooms").forEach(function (a) {
    a.addEventListener("click", function (event) {
      event.preventDefault();
      openLocationDrawer();
    });
  });

  //bind showroom title click event in left showroom menu
  document.querySelectorAll(".gv-select-store").forEach(function (a) {
    a.addEventListener("click", function (event) {
      event.preventDefault();
      var customerId = this.getAttribute("data-customer-id");
      var locationId = this.getAttribute("data-showroom-id");
      var locationTitle = this.getAttribute("data-showroom-title");
      updateCustomerShowroom(locationId, locationTitle);
      if (customerId != null) {
        if (customerId.length > 0) {
          callCustomerShowroomAPI(customerId, locationId);
        }
      }
    });
  });

  displayShowroomSelected();
});
